function socialShare(url, title, code) {

    var regurl = encodeURI(url);
    var sharetitle = encodeURI(title);
    var emailtitle = decodeURI(sharetitle);

    var fburl = `https://www.facebook.com/sharer/sharer.php?u=${regurl}&title=${sharetitle}`;
    var twurl = `https://twitter.com/intent/tweet?text=${sharetitle} ${regurl}`;
    var pturl = `https://pinterest.com/pin/create/bookmarklet/?url=${regurl}&is_video=false&description=${sharetitle}`;
    var gpurl = `https://plus.google.com/share?url=${regurl}`;
    var emailurl = `mailto:?subject=${emailtitle}&amp;body=${regurl}`;
    var sharebuilder = `
        <ul class="social-share">
            <li><a onClick="ga('send', 'event', 'Registrations', 'Click', 'facebook share ${code}');" href="javascript: open_window('${fburl}',550,375);" aria-label="Share on Facebook"><span class="fab fa-facebook-official"></span></a></li>
            <li><a onClick="ga('send', 'event', 'Registrations', 'Click', 'twitter share ${code}');" href="javascript: open_window('${twurl}',550,375);" aria-label="Share on Twitter"><span class="fab fa-x-twitter"></span></a></li>
            <li><a onClick="ga('send', 'event', 'Registrations', 'Click', 'email share ${code}');" href="${emailurl}"  aria-label="Share on email"><span class="fas fa-envelope"></span></a></li>
        </ul>`;

    return sharebuilder;
}


